import { parse } from "util/parsers";
import type { Platforms } from "./types";
import { ECommerceShoppingPlatform } from "consts/ecommerce";

export class ShoppingPlatforms {
    public static get supportedPlatforms(): Platforms {
        return {
            [ECommerceShoppingPlatform.WooCommerce]: {
                isActive: false
            }
        };
    }

    public static make(platforms: Platforms | string | null = null) {
        return new this(platforms);
    }

    private constructor(
        private platforms: string | null | Platforms
    ) { }

    public parse() {
        this.platforms = parse(String(this.platforms), {});

        return this;
    }

    public toKeys() {
        return Object.keys(this.platforms ?? {});
    }

    public toEntries() {
        return Object.entries(this.platforms ?? {});
    }

    public fromArray(platforms: Array<string>) {
        this.platforms = platforms.reduce((acc, platform) => ({
            ...acc,
            [platform]: {
                isActive: false
            }
        }), {} as Platforms);

        return this;
    }

    public activate(platform: ECommerceShoppingPlatform) {
        if (
            this.platforms &&
            typeof this.platforms === 'object' &&
            platform in this.platforms
        ) {
            this.platforms[platform].isActive = true;
        }

        return this;
    }

    public serialize() {
        return JSON.stringify(this.platforms);
    }
}

export default ShoppingPlatforms;